import React from 'react'

import { reverse } from 'named-urls'
import { Link } from 'react-router-dom'

import { Tooltip, IconButton } from '@material-ui/core'

import { Edit } from '@material-ui/icons'

import { routes } from 'routes'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from 'components/Table'

const ProfilesTable = ({ profiles, isLoading }) => {
  return (
    <Table isLoading={isLoading} emptyMessage="Nenhum perfil encontrado">
      <TableHead>
        <TableRow>
          <TableCell>Nome</TableCell>
          <TableCell>Descrição</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {profiles &&
          profiles.map(profile => (
            <TableRow key={profile.id}>
              <TableCell>{profile.name}</TableCell>
              <TableCell>{profile.description}</TableCell>
              <TableCell align="right">
                <Tooltip title="Editar">
                  <IconButton
                    component={Link}
                    to={reverse(routes.settings.profiles.edit, {
                      profileId: profile.id,
                    })}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  )
}

export default ProfilesTable
